"use client";

import Link from "next/link";

import { isUsableWebSession, useAuthStore } from "@/lib/auth-store";
import { authHrefFor, sanitizeNextPath } from "@/lib/navigation";
import { useMounted } from "@/lib/use-mounted";

type ActionLinkProps = {
  href: string;
  children: React.ReactNode;
  tone?: "primary" | "ghost" | "dark";
};

export function ActionLink({ href, children, tone = "primary" }: ActionLinkProps) {
  return (
    <Link href={href} className={`btn btn-${tone}`}>
      {children}
    </Link>
  );
}

export function ProtectedActionLink({
  children,
  next,
  context,
}: {
  children: React.ReactNode;
  next: string;
  context: string;
}) {
  const mounted = useMounted();
  const rawUser = useAuthStore((state) => state.user);
  const accessToken = useAuthStore((state) => state.accessToken);
  const demoMode = useAuthStore((state) => state.demoMode);
  const hasSession = mounted
    ? isUsableWebSession({ user: rawUser, accessToken, demoMode })
    : false;
  const safeNext = sanitizeNextPath(next);
  if (hasSession) {
    return (
      <Link href={safeNext} className="btn btn-primary">
        {children}
      </Link>
    );
  }

  return (
    <Link href={authHrefFor(safeNext, context)} className="btn btn-primary">
      {children}
    </Link>
  );
}
